import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-new-york-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./new-york-state-form.component.html",
  styleUrl: "./new-york-state-form.component.scss",
})
export class NewYorkStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
